import React from "react";
import ApexCharts from "react-apexcharts";
import { ApexOptions } from 'apexcharts';
import Chart from './lineChart';
import { defaultSeries, defaulCategories } from "../const";

const StateMonthlyPriceChart = ({stateName = 'State', series = defaultSeries, categories = defaulCategories}) => {

  const options: ApexOptions = {
    chart: {
      width: '100%',
      type: 'line',
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      }
    },
    colors:[
      '#1E90FF', // Blue
      '#FF6347', // Red (Tomato)
      '#32CD32', // Green (LimeGreen)
      '#8A2BE2', // BlueViolet
      '#FF1493', // DeepPink
      '#FFA500', // Orange
      '#FFD700', // Gold
      '#00FA9A', // MediumSpringGreen
      '#FF4500', // OrangeRed
      '#20B2AA'  // LightSeaGreen
    ],
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: 1,
      curve: 'straight',
      dashArray: [0,5,5,5,5,5,5,5,5,5,5,5]
    },
    title: {
      text: stateName + '',
      align: 'center'
    },
    legend: {
      tooltipHoverFormatter: function(val, opts) {
        return val + ' - <strong>' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '</strong>'
      }
    },
    markers: {
      size: 0
    },
    xaxis: {
      categories: categories,
      title: {
        text: 'Month'
      }
    },
    yaxis: { 
      title: {
        text: 'Price'
      }
    }
  };

  return (
      <Chart options={options} series={series} />
  );
};

export default StateMonthlyPriceChart;
